// ─── VEHICLE CHECKLIST TEMPLATE ───────────────────────────────────────────────
// Areas are worked inside-out. Each area collects multiple Before and After
// photos. Interior Package = interior areas only; Mint Condition (and anything
// unrecognized) = interior + exterior.

export const INTERIOR_AREAS = [
  // Driver's side, inside-out
  { key: "drv-door", label: "Driver door — inside panel" },
  { key: "drv-front-seat", label: "Driver front seat" },
  { key: "drv-front-floor", label: "Driver front floor board", note: "Must show the seat glides / rails" },
  { key: "dashboard", label: "Dashboard" },
  { key: "console", label: "Center console" },
  { key: "drv-rear-floor", label: "Driver rear floor board" },
  { key: "drv-rear-seat", label: "Driver rear seat" },
  { key: "drv-rear-glass", label: "Driver rear glass — from inside" },
  // Passenger's side
  { key: "pas-door", label: "Passenger door — inside panel" },
  { key: "pas-front-seat", label: "Passenger front seat" },
  { key: "pas-front-floor", label: "Passenger front floor board", note: "Must show the seat glides / rails" },
  { key: "pas-rear-floor", label: "Passenger rear floor board" },
  { key: "pas-rear-seat", label: "Passenger rear seat" },
  { key: "pas-rear-glass", label: "Passenger rear glass — from inside" },
];

export const EXTERIOR_AREAS = [
  { key: "ext-front", label: "Exterior — front", note: "Include front wheels" },
  { key: "ext-drv", label: "Exterior — driver side", note: "Include both driver-side wheels" },
  { key: "ext-pas", label: "Exterior — passenger side", note: "Include both passenger-side wheels" },
  { key: "ext-rear", label: "Exterior — rear", note: "Include rear wheels" },
];

// Pick the area list from the appointment's service/package string.
export function areasForService(service) {
  const s = (service || "").toUpperCase();
  if (s.includes("MINT CONDITION")) return [...INTERIOR_AREAS, ...EXTERIOR_AREAS];
  if (s.includes("INTERIOR")) return INTERIOR_AREAS;
  return [...INTERIOR_AREAS, ...EXTERIOR_AREAS]; // safe default: full list
}
